<template>
    <div>
        <div v-if="pages.data.length" class="flex justify-between items-center mb-5">
            <div class="flex flex-col">
                <search-filter v-model="form.search" class="w-full max-w-sm mr-4" @reset="reset" @input="submitSearch">
                    <!-- <label class="block text-grey-darkest">Trashed:</label>
                    <select
                        v-model="form.trashed"
                        class="mt-1 w-full form-select"
                        @change="reloadData"
                    >
                        <option :value="null" />
                        <option value="with">With Trashed</option>
                        <option value="only">Only Trashed</option>
                    </select> -->

                    <!-- <label class="block text-grey-darkest mt-3">Active:</label>
                    <select
                        v-model="form.active"
                        class="mt-1 w-full form-select"
                        @change="reloadData"
                    >
                        <option :value="null" />
                        <option value="true">Only Active</option>
                        <option value="false">Only Inactive</option>
                    </select> -->

                    <label class="block text-grey-darkest mt-3">Published:</label>
                    <select v-model="form.published" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null">All Pages</option>
                        <option value="true">Only Published pages</option>
                        <!-- <option value="false">Only Inactive</option> -->
                    </select>
                </search-filter>

                <active-filters :filters="filters" @remove-filter="removeFilter" />
            </div>

            <num-results :info="pages.info" name="pages" />

            <input type="hidden" v-model="form.orderBy" />
            <input type="hidden" v-model="form.sortOrder" />
        </div>

        <div class="flex items-center justify-between mb-5"></div>

        <table v-if="pages.data.length" class="w-full whitespace-no-wrap bg-white rounded text-left shadow">
            <thead>
                <tr class="text-teal-800 font-bold">
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('id')" class="hover:underline"> ID<sort-icon col="id" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                    </th>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('scraper')" class="hover:underline">
                            Scraper<sort-icon col="scraper" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('url')" class="hover:underline"> URL<sort-icon col="url" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                    </th>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('sustainability_score')" class="hover:underline">
                            <i class="fad fa-leaf mr-1"></i>Score<sort-icon col="sustainability_score" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('job_offer_count')" class="hover:underline">
                            Joboffer<sort-icon col="job_offer_count" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('created_at')" class="hover:underline">
                            First seen<sort-icon col="created_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('last_seen_at')" class="hover:underline">
                            Last seen<sort-icon col="last_seen_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('last_downloaded_at')" class="hover:underline">
                            <i class="fad fa-download mr-1"></i>downloaded<sort-icon col="last_downloaded_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('last_parsed_at')" class="hover:underline">
                            <i class="fad fa-layer-plus mr-1"></i>persisted<sort-icon col="last_parsed_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </th>
                </tr>
            </thead>

            <tr v-for="(page, index) in pages.data" class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900" :class="{ 'bg-teal-100': !(index % 2) }">
                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.scraperpages.show', page.id)" tabindex="-1">
                        {{ page.id }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.scraperpages.show', page.id)" tabindex="-1">
                        {{ page.scraper.name }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t max-w-xs truncate">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.scraperpages.show', page.id)" tabindex="-1">
                        {{ page.url_short }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <div v-if="page.sustainability_score" :class="page.published ? 'text-green-500' : 'text-gray-500'">
                        <i class="fad fa-leaf mr-1" :style="page.published ? '--fa-secondary-opacity: 0.75' : ''"></i>
                        {{ page.sustainability_score }}
                    </div>
                </td>

                <td class="px-3 border-t">
                    <inertia-link v-if="page.job_offer" :href="route('admin.joboffers.show', page.job_offer.id)" target="_blank">
                        <i class="fal fa-file-user mr-1"></i>
                        {{ page.job_offer.id }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t" width="170">
                    <div v-if="page.created_at">
                        {{ moment(page.created_at).fromNow(false) }}
                    </div>
                </td>

                <td class="px-3 border-t" width="170">
                    <div v-if="page.last_seen_at" :class="moment().diff(moment(page.last_seen_at), 'hours') > 24 ? 'text-red-500' : ''">
                        {{ moment(page.last_seen_at).fromNow(false) }}
                    </div>
                </td>

                <td class="px-3 border-t" width="170">
                    <div v-if="page.last_downloaded_at">
                        {{ moment(page.last_downloaded_at).fromNow(false) }}
                    </div>
                </td>

                <td class="px-3 border-t" width="170">
                    <div v-if="page.last_parsed_at">
                        {{ moment(page.last_parsed_at).fromNow(false) }}
                    </div>
                </td>

                <td class="text-right px-3 pr-6 border-t text-center" width="100">
                    <inertia-link :href="route('admin.scraperpages.download', page.id)" method="patch" @click="setTempLoading('downloading' + page.id)" preserve-scroll preserve-state>
                        <i class="fas text-teal-600 hover:text-teal-800" :class="loading == 'downloading' + page.id ? 'fa-spinner fa-pulse' : 'fa-download'"></i>
                    </inertia-link>

                    <inertia-link
                        :href="route('admin.scraperpages.parse', page.id)"
                        method="patch"
                        class="ml-3"
                        @click="setTempLoading('scrapeing' + page.id)"
                        preserve-scroll
                        preserve-state
                    >
                        <i class="fad text-teal-600 hover:text-teal-800" :class="loading == 'scrapeing' + page.id ? 'fa-spinner fa-pulse' : 'fa-layer-plus'"></i>
                    </inertia-link>
                </td>
            </tr>
        </table>

        <pagination :links="pages.links" />
    </div>
</template>

<script>
import _ from "lodash";
import SortIcon from "@/admin/Shared/SortIcon";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Pagination from "@/admin/Shared/Pagination";
import SearchFilter from "@/admin/Shared/SearchFilter";
import ActiveFilters from "@/admin/Shared/ActiveFilters";
import NumResults from "@/admin/Shared/NumResults";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";

export default {
    mixins: [Helpers],

    components: {
        Pagination,
        SearchFilter,
        ActiveFilters,
        SortIcon,
        // ActiveToggle: ToggleActiveIcon,
        NumResults,
        Breadcrumbs
    },

    props: {
        pages: Object,
        filters: Object
    },

    data() {
        return {
            form: {
                trashed: this.filters.trashed,
                active: this.filters.active,
                search: this.filters.search,
                published: this.filters.published,
                orderBy: this.filters.orderBy,
                sortOrder: this.filters.sortOrder
            }
        };
    },
    methods: {
        reloadData() {
            let queryParams = _.pickBy(this.form);
            this.$inertia.replace(this.route("admin.scraperpages.index", Object.keys(queryParams).length ? queryParams : { remember: "forget" }));
        },

        sort(col) {
            this.form.sortOrder = this.getNewSortOrder(col, this.form.orderBy, this.form.sortOrder);
            this.form.orderBy = col;
            this.reloadData();
        },

        submitSearch: _.debounce(function() {
            this.reloadData();
        }, 250),

        reset() {
            this.form = _.mapValues(this.form, () => null);
            this.reloadData();
        },

        removeFilter(filterName) {
            this.form[filterName] = null;
            this.reloadData();
        }
    }
};
</script>
